import React from 'react'
import PlanCentral from '../../admin/PlanCentral'
import V3PageBridgeFrame from '../V3PageBridgeFrame'

export default function V3PlanCentralPage() {
  return (
    <V3PageBridgeFrame>
      <PlanCentral />
    </V3PageBridgeFrame>
  )
}
